import React, { createContext, useContext } from 'react';
import { createTrackerDispatch } from '../../../../shared_modules/baui-utils/client/tracking/dispatch';

export const TrackingContext = createContext(null);

export function useTrackingContext() {
  const tracking = useContext(TrackingContext);

  return tracking;
}

export default function TrackingProvider({ tracker, context, hooks, config, children }) {
  const tracking = createTrackerDispatch(tracker, context, hooks, config);

  return <TrackingContext.Provider value={tracking}>{children}</TrackingContext.Provider>;
}

